import { useState, useEffect } from 'react';
import { Box, LinearProgress, Typography, Modal, Snackbar, Alert, Backdrop } from '@mui/material';
import { styleModalProgreso } from "../../estilo/modal";

const ProgressBarModal = ({ open, duration, progreso, message, snackbarMessage, severity, onClose }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [progress, setProgress] = useState(0);
  const [forceClose, setForceClose] = useState(false);
  const [shouldReset, setShouldReset] = useState(false); 

  // 1. Reiniciar al abrir
  useEffect(() => {
    if (open) {
      setShouldReset(true);
    }
  }, [open]);

  // 2. Aplicar reinicio en efecto dedicado
  useEffect(() => {
    if (shouldReset) {
      setProgress(0);
      setSnackbarOpen(false);
      setForceClose(false);
      setShouldReset(false);
    }
  }, [shouldReset]);

  // 3. Progreso manual
  useEffect(() => {
    setProgress(0);

    if (open && progreso !== undefined) {
      setProgress(progreso);
      if (progreso >= 100) {
        setSnackbarOpen(true);
        onClose();
        setTimeout(() => setSnackbarOpen(false), 3000);
      }
    }
  }, [progreso, onClose, open]);

  // 4. Progreso automático
  useEffect(() => {
    setProgress(0);

    if (open && duration && progreso === undefined) {
      let progressValue = 0;
      const interval = duration / 100;

      const timer = setInterval(() => {
        if (forceClose) {
          clearInterval(timer);
          return;
        }
        progressValue += 1;
        setProgress(progressValue);
        if (progressValue >= 100) {
          clearInterval(timer);
          setSnackbarOpen(true);
          onClose();
          setTimeout(() => setSnackbarOpen(false), 3000);
        }
      }, interval);

      return () => clearInterval(timer);
    }
  }, [open, duration, forceClose, onClose, progreso]);

  // 5. Cierre forzado
  useEffect(() => {
    if (!open && progress < 100) {
      setForceClose(true);
      setSnackbarOpen(true);
      setProgress(100);
      setTimeout(() => setSnackbarOpen(false), 3000);
    }
  }, [open, progress]);

  return (
    <>
      <Backdrop open={open} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 100 }}>
        <Modal open={open} aria-labelledby="progress-bar-modal">
          <Box sx={styleModalProgreso}>
            <Typography variant="h6" gutterBottom>
              {message || 'Procesando...'}
            </Typography>
            <LinearProgress variant="determinate" value={progress} sx={{ mt: 2 }} />
            <Typography variant="body2" sx={{ mt: 1 }}>{`${Math.round(progress)}%`}</Typography>
          </Box>
        </Modal>
      </Backdrop>
      <Snackbar open={snackbarOpen} autoHideDuration={5000} onClose={() => setSnackbarOpen(false)}>
        <Alert onClose={() => setSnackbarOpen(false)} severity={severity || 'success'} sx={{ width: '100%' }}>
          {snackbarMessage || 'Proceso completado con éxito'}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ProgressBarModal;
